import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Avatar3D from './Avatar3D'

const AvatarCelebration = ({
  trigger,
  character,
  celebrationType = 'task_complete',
  customMessage,
  pointsEarned = null, // New prop for actual points
  onComplete
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const [animationType, setAnimationType] = useState('celebrate')
  const [message, setMessage] = useState('')

  const celebrationMessages = {
    task_complete: [
      "Awesome job! 🌟",
      "You're amazing! ⭐",
      "Keep it up! 🎉",
      "Fantastic work! 🏆",
      "You rock! 🎊",
      "Well done! 👏",
      "Super star! ⚡",
      "Incredible! 🌈"
    ],
    level_up: [
      "Level Up! 🚀",
      "You're getting stronger! 💪",
      "New level unlocked! 🔓",
      "Amazing progress! 📈",
      "You're on fire! 🔥"
    ],
    reward_earned: [
      "Reward earned! 🎁",
      "You deserve this! 🏅",
      "Prize time! 🎪",
      "Well earned! 💎",
      "Congratulations! 🎯"
    ],
    streak: [
      "Streak master! ⚡",
      "On a roll! 🔥",
      "Unstoppable! 💫",
      "Keep the streak! 🏃‍♂️",
      "Consistency king! 👑"
    ]
  }

  const animationTypes = {
    task_complete: ['celebrate', 'bounce', 'pop'],
    level_up: ['spin', 'celebrate'],
    reward_earned: ['wiggle', 'bounce'],
    streak: ['celebrate', 'spin']
  }

  useEffect(() => {
    if (trigger) {
      // Select random message and animation
      const messages = celebrationMessages[celebrationType] || celebrationMessages.task_complete
      const animations = animationTypes[celebrationType] || animationTypes.task_complete

      const randomMessage = customMessage || messages[Math.floor(Math.random() * messages.length)]
      const randomAnimation = animations[Math.floor(Math.random() * animations.length)]

      setMessage(randomMessage)
      setAnimationType(randomAnimation)
      setIsVisible(true)
    }
  }, [trigger, celebrationType, customMessage])

  const handleAnimationComplete = () => {
    setIsVisible(false)
    if (onComplete) {
      onComplete()
    }
  }

  return (
    <Avatar3D
      character={character}
      isVisible={isVisible}
      animation={animationType}
      message={message}
      pointsEarned={pointsEarned} // Pass the actual points earned
      onAnimationComplete={handleAnimationComplete}
      size="large"
    />
  )
}

export default AvatarCelebration